export const tabIds = {
  BROWSE: 'browse',
  QUIZ_BUILDER: 'quiz-builder',
};

export const ACTIONS = {
  SET_ACTIVE_TAB: 'set-active-tab',
  SET_IS_DIRTY: 'set-is-dirty',
  SET_QUIZ_TITLE: 'set-quiz-title',
  ADD_QUESTIONS_TO_QUIZ: 'add-questions-to-quiz',
  PUSH_QUESTIONS_INTO_QUIZ: 'push-questions-into-quiz',
  EMPTY_MY_QUIZ_PENDING: 'empty-my-quiz-pending',
  RESET_QUIZ: 'reset-quiz',
  SET_NEW_QUIZ: 'set-new-quiz',
  SET_MY_QUIZ: 'set-my-quiz',
  SET_ACTIVE_STIMULUS_FILTERS: 'set-active-stimulus-filters',
  SET_LOADED_DATA: 'set-loaded-data',
  SET_EDIT_ASSESSMENT_PROPS: 'set-edit-assessment-props',
  CLOSE_AND_RESET_QUIZ: 'close-and-reset-quiz',
  SET_SUBJECTS: 'set-assessment-subjects',
  SAVE_QUIZ: 'save-quiz',
  UPDATE_ITEM_USAGE: 'update-item-usage',
  UPDATE_ITEM_ASSIGNEES: 'update-item-assignees',
  ROLLBACK_QUIZ: 'rollback-quiz',
  SET_TEACHER_SECTIONS: 'set-teacher-sections',
  SET_SUBJECT_INFO: 'set-subject-info',
  TOGGLE_ITEMS_COLUMNS_VISIBLITY: 'toggle-items-columns-visiblity',
  MOVE_ITEMS_COLUMN: 'move-items-column',
  SET_ITEMS_COLUMNS_VISIBLITY: 'set-items-columns-visiblity',
  RESET_ITEMS_COLUMNS_VISIBLITY: 'reset-items-columns-visiblity',
  SET_LOADING_QUIZ: 'set-loading-quiz',
};
